import { BaseCard } from './BaseCard'
import { Select } from '@/components'
import { APIClient } from '@/services'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'

export const AboutUsCard = ({ item }: RenderItemProps) => {
  const { options } = APIClient.Session.useSession()

  const prompt = useProfilePrompt(item, 'inbound_source')

  return (
    <BaseCard prompt={prompt}>
      <Select
        {...prompt.form.register('inbound_source')}
        options={options?.inbound_source ?? []}
        arrowIconName='chevron-right'
        placeholder='Select'
        variants={['noError', 'prompt']}
        onMenuOpen={() => BaseCard.setOpenPortal(prompt, true)}
        onMenuClose={() => BaseCard.setOpenPortal(prompt, false)}
      />
    </BaseCard>
  )
}
